import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=7b5f874e&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=7b5f874e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5f874e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b5f874e')) {
      api.createRecord('7b5f874e', component.options)
    } else {
      api.reload('7b5f874e', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=7b5f874e&scoped=true", function () {
      api.rerender('7b5f874e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wx/edit.vue"
export default component.exports